import { useNavigate } from "react-router-dom";
import { TfiLocationPin } from "react-icons/tfi";

import { callSocket } from "../../../utils/socket";

import CustomButton from "../../../common/CustomButton";

function LocationServiceStatusPrompt({ close = () => {}, mainMessage = "", subMessage = "", type = 0 }) {
    const navigate = useNavigate();

    return (
        <div id="location-service-status-propmt">
            <div>
                <div id="lssp-icon-wrapper" className="g-orange">
                    <TfiLocationPin />
                </div>
            </div>
            <div id="lssp-text-wrapper">
                <h4>{mainMessage}</h4>
                <p>{subMessage}</p>
            </div>
            <div>
                <CustomButton
                    className="active"
                    onClick={() => {
                        close();
                        navigate("/");
                    }}
                >
                    Back to indi
                </CustomButton>

                {type == 1 && (
                    <CustomButton
                        className="mt-3"
                        onClick={() => {
                            callSocket("/interact-native-component", { type: "location-settings" });
                        }}
                    >
                        Open Settings
                    </CustomButton>
                )}
            </div>
        </div>
    );
}

export default LocationServiceStatusPrompt;
